import FileManager from "./file-manager";
import {
    addListenerMulti,
    findDeleteButton,
    findFileDiv,
    isAdvancedUpload,
} from "./helpers";

window.addEventListener("DOMContentLoaded", () => {
    const fileBoxes = document.getElementsByClassName(
        "c-file-box"
    ) as HTMLCollectionOf<HTMLDivElement>;

    if (!fileBoxes["length"]) return;

    const firstBox = fileBoxes[0];

    if (!firstBox.dataset.guid) return;

    const appGuid = firstBox.dataset.guid;
    const tags = firstBox.dataset.tags || '';
    const fm = new FileManager(appGuid, tags);

    for (let box of Array.from(fileBoxes)) {
        //If onClick target is file delete button respond to click
        box.addEventListener("click", (e) => {
            const target = e.target;
            let btnElement: ReturnType<typeof findDeleteButton>;

            if (target instanceof HTMLElement) {
                btnElement = findDeleteButton(target, box);
            }

            if (!btnElement) return;

            e.preventDefault();

            const fileDiv = findFileDiv(btnElement, box);

            if (fileDiv?.dataset.id) {
                fm.deleteFile(fileDiv);
            }
        });

        const boxInput = box.querySelector("input");

        if (boxInput) {
            //Handle file updates in input[type="file"]
            boxInput.addEventListener("change", (e) => {
                const target = e.target as HTMLInputElement;
                const selectedFiles = target.files;

                if (selectedFiles) fm.uploadFiles(box, selectedFiles);
            });
        }

        if (!isAdvancedUpload()) return;

        //If browser supports drag drop add it to file upload.
        addListenerMulti(
            box,
            "drag dragstart dragend dragover dragenter dragleave drop",
            (e: Event) => {
                e.preventDefault();
                e.stopPropagation();
            }
        );

        addListenerMulti(box, "dragover dragenter", () => {
            box.classList.add("is-dragover");
        });

        addListenerMulti(box, "dragleave dragend drop", () => {
            box.classList.remove("is-dragover");
        });

        box.addEventListener("drop", (e) => {
            const droppedFiles = e?.dataTransfer?.files;

            if (!droppedFiles) return;

            fm.uploadFiles(box, droppedFiles);
        });
    }
});